import { FiGithub, FiLinkedin } from "react-icons/fi";
// import { FiGithub, FiLinkedin, FiInstagram } from "react-icons/fi";

import styled from "styled-components";

const profiles = [
  {
    icon: <FiGithub />,
    path: "https://github.com/DevelopedBy-Siva",
  },
  {
    icon: <FiLinkedin />,
    path: "https://www.linkedin.com/in/sivasanker-np",
  },
  // {
  //   icon: <FiInstagram />,
  //   path: "https://instagram.com/sivasanker_np",
  // },
];

export default function Profile() {
  return (
    <Container>
      {profiles.map((item, index) => (
        <a key={index} href={item.path} target="_blank" rel="noreferrer">
          {item.icon}
        </a>
      ))}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  width: 100%;
  gap: 40px;
  margin-top: 20px;

  a {
    text-decoration: none;
    color: #abababff;
    font-size: 32px;

    :hover {
      color: #fff;
    }
  }

  @media (max-width: 768px) {
    a {
      font-size: 25px;
    }
  }
`;
